/* eslint-disable */

import { AnyAction } from 'redux';
import Phone from '~/lib/Phone';
import * as actionTypes from '../actions/actionTypes';

export enum EnumCallStatus {
  CALL_INCOMING = 'CALL_INCOMING',
  CALL_BUSY = 'CALL_BUSY',
  CALL_OUTGOING = 'CALL_OUTGOING',
  CALL_NOANSWER = 'CALL_NOANSWER',
  CALL_FAILED = 'CALL_FAILED',
  CALL_FINISHED = 'CALL_FINISHED',
}

export interface IAnnouncements {
  id: number;
  name: string;
  duration: string;
}

interface IPhoneState {
  callInProgress: boolean;
  callStatus: EnumCallStatus | null; // INCOMING, OUTGOING, ACCEPTED, TERMINATED, FAILED
  ua: Phone | null;
  error: string | null;
  sipCredentials: string | null;
  extensions: [];
  favoriteAgents: [];
  socketIo: null;
  voiceMessages: {};
  announcements: IAnnouncements[];
}

const initialState: IPhoneState = {
  callInProgress: false,
  callStatus: null,
  ua: null,
  error: null,
  sipCredentials: null,
  extensions: [],
  favoriteAgents: [],
  socketIo: null,
  voiceMessages: {},
  announcements: [],
};

const reducer = (state: IPhoneState = initialState, action: AnyAction) => {
  switch (action.type) {
    case actionTypes.PHONE_SET_NEW_UA:
      return {
        ...state,
        ua: action.ua,
      };
    case actionTypes.PHONE_REGISTER_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case actionTypes.CALL_IN_PROGRESS:
      return {
        ...state,
        callInProgress: action.callInProgress,
      };
    case actionTypes.CALL_STATUS:
      return {
        ...state,
        callStatus: action.callStatus,
      };
    case actionTypes.UPDATE_CREDENTIALS:
      return {
        ...state,
        sipCredentials: action.sipCredentials,
      };
    case actionTypes.GET_EXTENSIONS:
      return {
        ...state,
        extensions: action.extensions,
      };
    case actionTypes.UPDATE_EXTENSIONS:
      return {
        ...state,
        extensions: action.extensions,
      };
    case actionTypes.SAVE_FAVORITE_AGENTS:
      return {
        ...state,
        favoriteAgents: action.favoriteAgents,
      };
    case actionTypes.SAVE_SOCKET_IO:
      return {
        ...state,
        socketIo: action.socketIo,
      };
    case actionTypes.VOICE_MESSAGE_RECEIVED:
      return {
        ...state,
        voiceMessages: action.voiceMessages,
      };
    case actionTypes.SET_ANNOUNCEMENTS:
      return {
        ...state,
        announcements: action.announcements,
      };
    case actionTypes.RESET_PHONES:
      return initialState;
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
